import React, {useMemo} from "react";
import {SocketProvider} from "@unibuddy/sockets";

import useAuth from "shared/Auth/hooks/useAuth";
import {getenv} from "../../../util/getEnv";

export function SocketWrapperProvider({children}: {children: React.ReactNode}) {
    const {authState} = useAuth();
    const token: string = authState?.token ?? "";
    const tokenScheme: string = authState?.tokenScheme ?? "";

    const memoisedToken = useMemo(() => {
        return {token, scheme: tokenScheme};
    }, [token, tokenScheme]);

    const socketCredentials = useMemo(() => {
        return {
            PUSHER_APP_KEY: getenv("PUSHER_APP_KEY") as string,
            PUSHER_APP_CLUSTER: getenv("PUSHER_APP_CLUSTER") as string,
            PUSHER_AUTH_URL: getenv("GATEWAY_URL") as string,
        };
    }, []);

    return (
        <SocketProvider token={memoisedToken} socketCredentials={socketCredentials}>
            {children}
        </SocketProvider>
    );
}
